import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AddPackageService {
  constructor(private http:HttpClient) { }

  addPackage(data:any){
    return this.http.post(environment.apiUrl + "packages/addNew" , data)
  }

  addPackageCSV(data:any){
    return this.http.post(environment.apiUrl + "packages/addNewCSV" , data)
  }



// getData(){
//  return this.http.get("http://maps.googleapis.com/maps/api/distancematrix/json?origins=54.406505,18.67708&destinations=54.446251,18.570993&mode=driving&language=en-EN&sensor=false")
// }

checkVerifyCity(data:any){
  return this.http.post(environment.apiUrl1 + "city/verify"  , data)
}

getAllVehicle(data:any){
  return this.http.post(environment.apiUrl + "vehicles/get/all" , data)
}

vehicleBooking(data:any){
  return this.http.post(environment.apiUrl + "vehiclesbooking/addNew" , data)
}

}
